export interface LoadingStateProps {
  readonly label?: string;
  readonly testId?: string;
  readonly compact?: boolean;
  readonly minHeightClassName?: string;
}

export function LoadingState(props: LoadingStateProps) {
  const label = props.label ?? "Загрузка…";
  const minH = props.minHeightClassName ?? (props.compact ? undefined : "min-h-[12rem]");
  return (
    <output
      aria-live="polite"
      aria-busy="true"
      data-testid={props.testId ?? "loading-state"}
      className={`flex items-center justify-center rounded-2xl border border-pad-200 bg-white px-4 py-8 ${minH ?? ""}`}
    >
      <span className="inline-flex items-center gap-2.5">
        <span
          className="pwz-spinner h-4 w-4 shrink-0 rounded-full border-2 border-ink-300 border-t-ink-950"
          aria-hidden="true"
        />
        <span className="pwz-eyebrow break-words">{label}</span>
      </span>
    </output>
  );
}
